import { useEffect, useRef } from "react"

export const useFocusByProp = (hasFocus) => {
    const itemRef = useRef(null)

    useEffect(() => {
        if(hasFocus) {
            itemRef.current.focus()
        }

        return () => itemRef.current && itemRef.current.blur()

    }, [hasFocus])


    return [itemRef]
}

